<!-- <div class="monitorAvance"  > </div> -->


<div [style]="getDivPrincipal()">
    <div [style]="getCentro()">{{titulo}}</div>
    <div [style]="getSubtitulo()">{{porcentaje}}%</div>
</div>
